/* eslint-disable no-script-url */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { UserPreferenceContext } from 'routes/home/layouts/India/context';
import makeRequest from 'utils/makeRequest';
import InViewObserver from 'components/InViewObserver';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import VisualStoryCard from 'components_v2/common/CardVisualStory';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import ElementInView from 'components_v2/common/ElementInView';
import s from './VisualStories.scss';
import Listingheader from '../../../../home/components/common/ListingheaderV2';
import HeaderTab from '../../../../home/components/desktop/HeaderTabV2';

class VisualStories extends React.Component {
  constructor() {
    super();
    this.state = {
      headerItems: {},
    };
    this.tabName = '';
  }

  componentDidMount() {
    const { sectionData } = this.props;

    //for loading content
    if (sectionData && !Array.isArray(sectionData) && sectionData.dataUrl) {
      this.loadSectionData(sectionData.dataUrl);
    }
    //for loading Header of component
    // if (
    //   sectionData &&
    //   sectionData.subSections &&
    //   sectionData.subSections.dataUrl
    // ) {
    //   this.loadHeaderData(sectionData.subSections.dataUrl);
    // }
    // this.loadNavigationData();
  }

  loadNavigationData() {
    const { sectionData = {} } = this.props;
    if (sectionData.subSections && sectionData.subSections.dataUrl) {
      this.fetchNavigation(sectionData.subSections.dataUrl);
    }
  }

  fetchNavigation(dataUrl) {
    makeRequest
      .get(dataUrl, { isMobile: this.props.isMobile }, 'skipfeedengine')
      .then(data => {
        if (!(data && data.data)) {
          return;
        }
        const { items } = data.data;
        this.setState({
          // eslint-disable-next-line react/no-unused-state
          navItems: items,
          headerItems: data.data.items,
        });
      });
  }

  // loadHeaderData = dataUrl => {
  //   if (!dataUrl) {
  //     return;
  //   }

  //   makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
  //     if (data && data.data && data.data.items && data.data.items.length > 0) {
  //       //console.log('data : ', data.data);
  //       this.setState({
  //         headerItems: data.data.items,
  //       });
  //     }
  //   });
  // };

  loadSectionData = (dataUrl, ajaxCall) => {
    if (!dataUrl) {
      return;
    }
    this.setState({ loading: true });
    makeRequest.get(dataUrl, {}, 'skipfeedengine').then(data => {
      if (data && data.data && data.data.items && data.data.items.length > 0) {
        this.setState({
          items: data.data.items,
          ajaxCall: !!ajaxCall,
          loading: false,
        });
      } else {
        this.setState({ loading: false });
      }
    });
  };

  onTabsChange = params => {
    const { clickedItem: { name }, confirmMakingDefCity } = params;
    if (confirmMakingDefCity && name && this.context) {
      this.context.setLanguageVal(name, true);
    } else {
      if (params && params.clickedItem && params.clickedItem.dataUrl) {
        this.loadSectionData(
          params.clickedItem.dataUrl,
          true,
          params.clickedItem.path,
        );
      }

      if (params.clickedItem.name) {
        this.tabName = params.clickedItem.name;
      }
    }
  };

  renderHeader = () => {
    const { headerItems } = this.state;
    const { sectionData = {}, headerClickGa } = this.props;
    const sectionName = sectionData.name;
    const headerTabs = this.props.subSections || headerItems;

    if (
      headerTabs &&
      headerTabs instanceof Array &&
      !this.tabName &&
      headerTabs[0] &&
      headerTabs[0].name
    ) {
      this.tabName = headerTabs[0].name;
    }
    const headerGaAction =
      headerClickGa && headerClickGa.gaAction
        ? headerClickGa.gaAction
        : `${sectionName}Section_Actions`;
    const headerGaLabel =
      headerClickGa && headerClickGa.gaLabel
        ? headerClickGa.gaLabel
        : 'HeadingClick';
    return (
      <>
        {sectionName && (
          <Listingheader
            headingname={sectionName}
            headingLink={sectionData.link || sectionData.path}
            subheading={sectionData.subHeading}
            newga={`${headerGaAction}#${headerGaLabel}`}
            target={sectionData.target}
            ga4Type={sectionData?.ga4Type}
            ga4Category={sectionData?.ga4Category}
          >
            {headerTabs && headerTabs instanceof Array ? (
              <HeaderTab
                subSections={headerTabs}
                onChangeCallback={this.onTabsChange}
                loading={this.state.loading}
                newga={`${sectionData.name}_TabChange#Click_`}
                ga4Type={sectionData?.ga4Type}
                ga4Category={sectionData?.ga4Category}
              />
            ) : null}
          </Listingheader>
        )}
      </>
    );
  };

  render() {
    const {
      sectionData = {},
      gaOnscroll,
      cardWrapperClass,
      clickGaAction,
      gaLabelConnector,
      isEtimesArticle,
    } = this.props;
    let visualstoryData = sectionData;
    const gaSplit = gaOnscroll.split('#');
    const gaFinalonscroll = {
      gaAction: gaSplit[0],
      gaLabel: gaSplit[1],
    };

    if (this.state.ajaxCall) {
      visualstoryData = this.state.items;
    } else {
      visualstoryData = sectionData.items || this.state.items;
    }
    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadNavigationData();
        }}
        viewMargin="300px 0px 300px 0px"
        id={
          sectionData && sectionData.id && sectionData.id === 'trivia'
            ? sectionData.id
            : undefined
        }
      >
        <ElementInView
          gaAction={gaFinalonscroll.gaAction}
          gaLabel={gaFinalonscroll.gaLabel}
          className={`${s.vs_wrapper}`}
        >
          {sectionData.border &&
            sectionData.border === 'top' && (
              <InterSectionBorder border={sectionData.border} />
            )}
          {sectionData.subSections &&
            sectionData.subSections.dataUrl &&
            this.state.loading && <LoaderSpinner />}

          {this.renderHeader()}

          <VisualStoryCard
            sectionData={visualstoryData}
            gaData={gaFinalonscroll}
            cardType="click-visualstory"
            ajaxCall={this.state.ajaxCall}
            clickGaAction={clickGaAction}
            isMobile={this.props.isMobile}
            wrapperClass={cardWrapperClass}
            //  isMobile={this.props.isMobile}
            gaLabelConnector={gaLabelConnector}
            isEtimesArticle={isEtimesArticle}
            disableIsLarge={this.props.disableIsLarge}
            isToiWidget={
              this.props.sectionData &&
              this.props.sectionData.name &&
              this.props.sectionData.name === 'News Visual Stories'
            }
            ga4Type={sectionData?.ga4Type}
            ga4Category={sectionData?.ga4Category}
          />
        </ElementInView>
      </InViewObserver>
    );
  }
}
VisualStories.propTypes = {
  sectionData: PropTypes.shape({
    id: PropTypes.string,
    subSections: PropTypes.shape({
      dataUrl: PropTypes.string,
    }),
    dataUrl: PropTypes.string,
  }).isRequired,
  gaOnscroll: PropTypes.string,
  subSections: PropTypes.shape({}),
  geoCityData: PropTypes.shape({
    city: PropTypes.string,
  }),
  cardWrapperClass: PropTypes.string,
  headerClickGa: PropTypes.shape({}),
  clickGaAction: PropTypes.string,
  isMobile: PropTypes.bool,
  gaLabelConnector: PropTypes.string,
  isEtimesArticle: PropTypes.bool,
};

VisualStories.defaultProps = {
  geoCityData: {},
  subSections: null,
  gaOnscroll: '',
  cardWrapperClass: undefined,
  headerClickGa: undefined,
  isMobile: false,
  clickGaAction: null,
  // isMobile: false,
  gaLabelConnector: '',
  isEtimesArticle: false,
};
const mapStateToProps = state => ({
  isMobile: state.isMobile,
});

VisualStories.contextType = UserPreferenceContext;

export default connect(mapStateToProps)(VisualStories);
